<script lang="ts">
	export let className = 'size-5';
</script>

<!--
	Source: Figma
	Copyright: unknown
	Origin: Figma
-->

<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="currentColor" class={className}>
  <path d="M11.4561 10.2778L16.9783 4.7561C17.3039 4.43055 17.3039 3.90333 16.9783 3.57777C16.6528 3.25222 16.1256 3.25222 15.8 3.57777L10.2778 9.09944L4.75611 3.57722C4.43056 3.25222 3.90278 3.25222 3.57722 3.57722C3.25222 3.90277 3.25222 4.43055 3.57722 4.7561L9.09944 10.2778L3.57722 15.7994C3.25167 16.125 3.25167 16.6522 3.57722 16.9778C3.74 17.1405 3.95333 17.2217 4.16667 17.2217C4.38 17.2217 4.59333 17.1405 4.75611 16.9778L10.2778 11.4561L15.7994 16.9778C15.9622 17.1405 16.1756 17.2217 16.3889 17.2217C16.6022 17.2217 16.8156 17.1405 16.9783 16.9778C17.3039 16.6522 17.3039 16.125 16.9783 15.7994L11.4561 10.2778Z"/>
</svg>
